__turbopack_context__.v({
  "acheivername": "privacy-module__SjYoCa__acheivername",
  "acheivername1": "privacy-module__SjYoCa__acheivername1",
  "acheiverrank": "privacy-module__SjYoCa__acheiverrank",
  "pagemaintitle": "privacy-module__SjYoCa__pagemaintitle",
});
